<template>
  <div class="home">
    <div class="banner" :style="{ backgroundImage: 'url(' + pageDetail.homepagebanner + ')' }">
      <div class="container">
        <div :class="'banner-text ' + [toptitle2 ? 'toptitle2' : '']">
          <h2 style="opacity: 0.2;">{{ pageDetail.homepagetext }}</h2>
          <h2 style="opacity: 0.8;">{{ pageDetail.homepagetext2 }}</h2>
          <h5>{{ pageDetail.homepagetext3 }}</h5>
          <h5>{{ pageDetail.homepagetext4 }}</h5>
        </div>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container homepro">
        <el-row :gutter="10">
          <el-col :span="10">
            <div class="proshowleft">
              <div class="text">
                <h3>核心科研</h3>
                <p>Advanced Scientific Research Services</p>
              </div>
              <div>
                <img src="../assets/homepro0.png"></img>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="proshow" @click="gourl('products?catid=2')">
              <div class="img"><img src="../assets/homepro1.png"></img></div>
              <div class="text">
                <h4>BioTrekTMA23plus⼈类DNA⾝份鉴定试剂盒</h4>
                <p>
                  鉴定试剂盒采⽤6⾊荧光标记，对常⽤的23个STR位点（包括新CODIS系统涵BioTrek™A23plus⼈类DNA⾝份鉴定试剂盒盖的20个核⼼基因座）和⼀个性别位点Amelogenin、⼀个y-indel位点进⾏复合扩增；基因座数⽬的增加...
                </p>
              </div>
            </div>
            <div class="proshow" @click="gourl('products?catid=3')">
              <div class="text">
                <h4>⼀次性使⽤腔镜直线型切割吻合器及切割组件</h4>
                <p>
                  该器械由器⾝、切割组（燕红國）件、传动装置及切割⼑⽚组成。本产品是⽆菌、单⼀患者（T含室）使⽤的器械，可同时切割和吻（国合不制）合组织。共有六排交错排列的...
                </p>
              </div>
              <div class="img"><img src="../assets/homepro2.png"></img></div>
            </div>
            <div class="proshow" @click="gourl('products?catid=4')">
              <div class="img"><img src="../assets/homepro3.png"></img></div>
              <div class="text">
                <h4>一次性使⽤电动腔镜直线型切割吻合器及钉仓组件</h4>
                <p>
                  该器械由器⾝、钉仓组抵钉庭）•件、传动装置及切割⼑⽚组成。本产品是⽆菌、单⼀患者使⽤的器械，可同时切割和吻（T⾷电•合组织。共有六排交错排列的吻合钉，切割线每侧...
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="midbanner" :style="{ backgroundImage: 'url(' + pageDetail.homepagebanner2 + ')' }">
        <div class="container">
          <div class="banner-text">
            <h3><span>“</span>打造精准检测领域的领军企业<span>”</span></h3>
          </div>
        </div>
      </div>

      <div class="container homeabout">
        <el-row :gutter="60">
          <el-col :span="12"><img src="../assets/homeabout.png"></img></el-col>
          <el-col :span="12">
            <h3>关于诺辰</h3>
            <p>About NuoCheng Company</p>
            <p>
              诺⾠（河南）⽣物技术有限公司成⽴于2024年，是博奥润康⽣物科技旗下专注于⼆类、三类医疗器械技术企业，拥有3000㎡标准化厂房，其中包括四个万级检测实验室和两个⼗万级⽣产车间；我们的使命是“创新驱动发展，科技服务健康”——为司法鉴定领域、医疗机构提供精准⾼效的优质产品，推动⼈类健康进步...
            </p>
            <div><el-button type="primary" round @click="gourl('about')">了解更多 <i class="el-icon-arrow-right
"></i></el-button></div>
          </el-col>
        </el-row>
        <div class="numbers">
          <ul>
            <li>
              <strong>15</strong>
              <p>诺辰生物深耕15年</p>
            </li>
            <li>
              <strong>200+</strong>
              <p>科研团队成员超200名</p>
            </li>
            <li>
              <strong>80</strong>
              <p>80余项专利</p>
            </li>
            <li>
              <strong>5000+</strong>
              <p>服务客户超5000家</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi } from '@/api'

export default {
  name: 'Home',
  data() {
    return {
      pageDetail: '',
      toptitle2: false,
      products: []
    }
  },
  created() {
    // 首先尝试获取当前已有的系统设置
    let systemSettings = this.$store.getters.systemSettings
    if (Object.keys(systemSettings).length > 0) {
      // 如果已经有数据，直接使用
      this.pageDetail = systemSettings
    } else {
      // 如果没有数据，输出提示信息
    }

    // 监听系统设置变化
    this.unwatch = this.$store.watch(
      (state) => state.systemSettings,
      (newSettings) => {
        if (newSettings && Object.keys(newSettings).length > 0) {
          this.pageDetail = newSettings
        }
      }
    )

    setTimeout(() => {
      this.toptitle2 = true;
    }, 500);
  },
  mounted() {
    // this.fetchProducts()
  },
  methods: {
    gourl(e) {
      this.$router.push({ path: e })
    }
    // async fetchProducts() {
    //   try {
    //     const response = await productApi.getProductList()
    //     if (response.code === 200) {
    //       // 只显示前两个产品
    //       this.products = response.data.slice(0, 2)
    //     }
    //   } catch (error) {
    //     console.error('获取产品列表失败:', error)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.home {
  text-align: justify;

  .banner {
    height: 700px;
    width: 100%;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    .banner-text {
      opacity: 0;
      margin-top: 150px;
      text-shadow: -2px -2px 1px #313131;

      h2 {
        font-size: 68px;
        letter-spacing: 0px;
        line-height: 32px;
        color: #FFFFFF;
      }

      h5 {
        color: #fff;
        margin: 0;
        padding: 0;
        font-size: 20px;
        font-weight: normal;
      }
    }

    .toptitle2 {
      margin-top: 0px;
      opacity: 1;
      transition: all 1000ms ease-in-out;
    }

  }

  .midbanner {
    height: 400px;
    width: 100%;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto;
    display: flex;
    align-items: center;
    margin: 0 0 80px 0;

    .banner-text {
      text-align: center;

      h3 {
        font-size: 50px;
        letter-spacing: 0px;
        line-height: 32px;
        color: #fff;

        span {
          color: #2A82E4;
          position: relative;
          top: -10px;
          padding: 0 20px;
          font-family: 'Times New Roman', Times, serif;
        }
      }
    }
  }
}

.homepro {
  padding: 80px 0;

  p {
    color: #666;
    line-height: 1.5;
  }

  .proshowleft {
    .text {
      padding: 110px 0 120px 50px;
    }

    h3 {
      font-size: 40px;
      margin: 0;
      color: #000;
    }

    img {
      width: 100%;
      height: 710px;
    }
  }

  .proshow {
    margin-bottom: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 30px;
      color: #000;
    }

    .img {
      width: 50%;
      height: 350px;
      overflow: hidden;
      border-radius: 12px;

      img {
        width: 100%;
      }
    }

    .text {
      width: 50%;
      padding: 20px;
      height: 100%;

      h4 {
        font-size: 24px;
        margin: 0;
      }
    }

    img {
      width: 100%;
      display: block;
    }
  }

  .proshow:hover {
    border-radius: 12px;
    background: #004DB8;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    p {
      color: #fff;
    }
  }
}

.homeabout {
  padding-bottom: 50px;

  img {
    width: 100%;
  }

  h3 {
    font-size: 40px;
    margin: 10px 0 0 0;
    padding: 0;
    color: #000;
  }

  p {
    color: #666;
    margin-bottom: 20px;
    line-height: 2;
  }

  .numbers {
    border: 1px solid #EEEEEE;
    box-shadow: 0px 2px 4px #eee;
    margin: 50px 0 0 0;
    padding: 30px 0;

    p {
      margin: 0;
    }

    ul {
      margin: 0;
      padding: 0;
    }

    li {
      margin: 0;
      padding: 0;
      list-style: none;
      display: inline-block;
      width: 25%;
      text-align: center;
    }

    strong {
      font-size: 40px;
      margin: 10px 0 0 0;
      padding: 0;
      color: #313131;
    }
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  #app {
    .home {
      .homepro {
        padding: 1rem;

        .proshow {
          display: block;

          .img {
            width: 100%;
          }

          .text {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
          }
        }

        .proshow:nth-child(2) {
          display: flex;
          flex-direction: column-reverse;
        }

        .proshowleft {
          img {
            height: 30rem;
          }

          .text {
            padding: 0;

          }
        }
      }

      .el-col-10 {
        width: 100%;
      }

      .el-col-14 {
        width: 100%;
      }

      .banner {
        height: 35rem;
        background-size: cover;
      }

      .midbanner {
        height: 15rem;
        margin-bottom: 3rem;

        .banner-text h3 {
          font-size: 1.8rem;

          span {
            top: 0;
          }
        }
      }

      .homeabout {
        padding: 0 30px 100px 30px;

        .el-col-12 {
          width: 100%;
        }

        .numbers {
          margin-bottom: 0;

          ul {
            li {
              width: 50%;
            }
          }
        }
      }
    }
  }
}
</style>